import React, { useState } from 'react';
import { Card, CardBody } from 'react-bootstrap';
import { TabContent, TabPane } from 'reactstrap';
import BreadCrumbs from '../../components/BreadCrumbs';
import PillNavigation from '../../components/SubNavBar';
import Roles from './Roles';
import FeatureGroups from './FeatureGroups';
import Features from './Features';
import PermissionsMatrix from './PermissionsMatrix';
// import { RolePermissionProvider } from './context/RolePermissionContext';
import './index.css';
import { NAV_LIST_ROLES_PERMISSIONS } from '../../constants/constans';

const RolesAndPermissions = () => {
  const [active, setActive] = useState(1);

  const toggle = (tab: any) => {
    setActive(tab);
  };

  return (
    // <RolePermissionProvider>
    <>
      <BreadCrumbs hasSubMenus={true} />
      <br />
      <Card className="roles-permission-whole-card">
        <CardBody>
          <div className="roles-permission-nav-bar">
            <PillNavigation
              navList={NAV_LIST_ROLES_PERMISSIONS}
              active={active}
              toggle={toggle}
            />
          </div>
          <hr />
          
          <TabContent activeTab={active} className="mt-4">
            {active === 1 && (
              <div className="sub-nav-bar-each-part">
                <TabPane tabId={1}>
                  <Roles />
                </TabPane>
              </div>
            )}
            {active === 2 && (
              <div className="sub-nav-bar-each-part">
                <TabPane tabId={2}>
                  <FeatureGroups />
                </TabPane>
              </div>
            )}
            {active === 3 && (
              <div className="sub-nav-bar-each-part">
                <TabPane tabId={3}>
                  <Features />
                </TabPane>
              </div>
            )}
            {active === 4 && (
              <div className="sub-nav-bar-each-part">
                <TabPane tabId={4}>
                  <PermissionsMatrix />
                </TabPane>
              </div>
            )}
          </TabContent>
        </CardBody>
      </Card>
    </>
    // </RolePermissionProvider>
  );
};

export default RolesAndPermissions;